import Blog from "./../components/blogapi";
import Navbar from "./../components/navbar/navbar";
import Header from "./../components/blogheader";
import Footer from "./../components/footer/footer";
import Newsletter from "./../components/homecomponents/newsletter4";
//import Exslide from "./../components/homecomponents/exslide";


const Blogpage = () => {
    return(
        <div>
            <Navbar/>
            <Header/>
            <Blog/>
           {/* <Exslide/> */}
           <Newsletter/>
            <Footer/>
        </div>
    )
}
export default Blogpage;